export function contractGreenCard(data) {
    return axios({
        url: `/api/test/insurance/greencard/contract/confirm`,
        method: 'post',
        data: data,
    });
}
